import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-configure-zoom-meetings',
  templateUrl: './configure-zoom-meetings.component.html',
  styleUrls: ['./configure-zoom-meetings.component.scss']
})
export class ConfigureZoomMeetingsComponent {
  formData = {
    apiKey: '',
    apiSecret: '',
    accountId: ''
  };

  constructor(private dialogRef: MatDialogRef<ConfigureZoomMeetingsComponent>) {}

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    console.log('Zoom Data Saved:', this.formData);
    this.dialogRef.close(this.formData);
  }
}
